import EMAILS from './emails'

function getBackofficerEmails() {
  return [EMAILS.RANDY, EMAILS.YUTA, EMAILS.ZAMIA, EMAILS.FERRY, EMAILS.ARIEL, EMAILS.PUTRI]
}

function getApprovalEmails() {
  return [EMAILS.RANDY, EMAILS.YUTA]
}

function getEditLeaveRequestEmails() {
  return [EMAILS.RANDY, EMAILS.YUTA, EMAILS.ZAMIA, EMAILS.PUTRI, EMAILS.ARIEL]
}

function getEditReimbursementEmails() {
  return [EMAILS.RANDY, EMAILS.YUTA, EMAILS.ZAMIA, EMAILS.PUTRI, EMAILS.ARIEL]
}

const PERMISSIONS = {
  getBackofficerEmails,
  getApprovalEmails,
  getEditLeaveRequestEmails,
  getEditReimbursementEmails,
}

export default PERMISSIONS
